"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderBarWrapper = exports.Main = void 0;
const flora_react_1 = require("@grupoboticario/flora-react");
const styles_1 = require("@mui/material/styles");
const SideCartDrawer_1 = require("../SideCartDrawer");
const drawerWidth = 280;
exports.Main = (0, styles_1.styled)('main', {
    shouldForwardProp: (prop) => !['menuIsOpen', 'cartIsOpen'].includes(prop),
})(({ theme, menuIsOpen, cartIsOpen, isMobile }) => (Object.assign(Object.assign({ flexGrow: 1, transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }), marginLeft: `-${drawerWidth}px`, paddingLeft: `${drawerWidth}px` }, (menuIsOpen && {
    transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
})), (cartIsOpen && {
    paddingRight: `${SideCartDrawer_1.SIDE_CART_DRAWER_WIDTH}px`,
    transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
    }),
}))));
exports.HeaderBarWrapper = (0, flora_react_1.styled)('nav', {
    position: 'sticky',
    width: '100vw',
    maxWidth: '100%',
    top: 0,
    left: 0,
    right: 0,
    zIndex: '$sticky',
});
